import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Remove = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2C6.49 2 2 6.49 2 12ZM3.25 12C3.25 7.17 7.17 3.25 12 3.25C16.83 3.25 20.75 7.17 20.75 12C20.75 16.83 16.83 20.75 12 20.75C7.17 20.75 3.25 16.83 3.25 12ZM8.25 12.62H15.75C16.09 12.62 16.37 12.34 16.37 12C16.37 11.66 16.09 11.38 15.75 11.38H8.25C7.91 11.38 7.63 11.66 7.63 12C7.63 12.34 7.91 12.62 8.25 12.62Z"
      fill="#565B6D"
    />
  </svg>
)

export default withDefaultStyles(Remove)
